/* "Complete your 3 for 2" cards in the bag and on the cart page.
   Lives in an asset, not inline in the snippet: the drawer is re-rendered
   with innerHTML, and inline scripts inserted that way never run — so for a
   shopper whose bag started empty a tap on a card opened the product page
   instead of adding the case. */
if (!window.__cloudCompleterBound) {
  window.__cloudCompleterBound = true;
  window.__cloudModelKey = (raw) => {
    const lower = String(raw || '').toLowerCase().trim();
    if (/samsung|galaxy|pixel|google/.test(lower)) return lower.replace(/[\s-]/g, '');
    return lower.replace(/iphone|apple/g, '').replace(/[\s\-_]/g, '');
  };
  /* Tapping the photo adds the case, same as the button. */
  document.addEventListener('click', (event) => {
    const tile = event.target.closest('[data-cloud-completer-tile]');
    if (!tile) return;
    const form = tile.closest('[data-cloud-completer-card]')?.querySelector('form');
    if (!form) return;
    event.preventDefault();
    form.requestSubmit ? form.requestSubmit(form.querySelector('[data-cloud-completer-add]')) : form.querySelector('[data-cloud-completer-add]')?.click();
  });
  document.addEventListener('submit', (event) => {
    const card = event.target.closest('[data-cloud-completer-card]');
    if (!card) return;
    const root = card.closest('[data-cloud-completer]');
    const key = window.__cloudModelKey(root?.dataset.cartModel || '');
    let map = {};
    try { map = JSON.parse(card.querySelector('[data-cloud-completer-map]')?.textContent || '{}'); } catch (_e) {}
    const hit = key ? map[key] : null;
    const input = event.target.querySelector('input[name="id"]');
    if (!hit || !input) {
      /* No model in the bag yet (or this case is not made for it): choose it on the product page. */
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(card.dataset.productUrl || '/');
      return;
    }
    input.value = hit[0];
  }, true);
}
  
